module.exports = __webpack_public_path__ + "nc_static/media/sw-release-acceptance.37d2e413.svg";